import React from 'react';
import Dashboard from '../components/Dashboard/Dashboard';
import CMSheader from '../components/CMSHeader';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import '../CMSstyle.scss';

const DashboardPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/adminlogin", { replace: true });
  };

  const username = user?.name || "Admin";

  return (
    <>
      <CMSheader onLogout={handleLogout} username={username} />
      <div className="dashboard-page">
        <Dashboard />
      </div>
    </>
  );
};

export default DashboardPage;
